import { UserManager, WebStorageStateStore } from "oidc-client";

const oidcConfig = {
  authority: "https://identity.dev.avimall.com",
  client_id: "libra-mapper",
  redirect_uri: `${window.location.origin}/callback`,
  response_type: "code",
  scope: "openid profile",
  post_logout_redirect_uri: `${window.location.origin}/`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
};

const userManager = new UserManager(oidcConfig);

export default userManager;
